import { render } from "./ContentTime.vue?vue&type=template&id=87dcff1c"
import script from "./ContentTime.vue?vue&type=script&lang=js"
export * from "./ContentTime.vue?vue&type=script&lang=js"

import "./ContentTime.vue?vue&type=style&index=0&id=87dcff1c&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__